module.exports = __webpack_public_path__ + "img/js30cssvar.89905b98.png";